module.exports = __webpack_public_path__ + "img/footer-image@1.5x.146efc9b.webp";